"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_OutOfTime_OnDeathAvoidedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
let Ability_OutOfTime_OnDeathAvoidedEventHandlerScript = class Ability_OutOfTime_OnDeathAvoidedEventHandlerScript {
    run(sequence, container, handler, event) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: event.subject,
            abilityKey: "OutOfTime",
            fallback: "blocked",
            onAnimated: sequence => {
                // remove harmful effects!
                container.getHarmfulEffects(event.subject).forEach(effect => container.cancelEffect(sequence, effect.id));
                const maxHealth = container.getMaxAttributeScore(event.subject, AttributeType_1.AttributeType.Health);
                container.applyBuffs({
                    sequence,
                    creatorId: event.subject,
                    targetId: event.subject,
                    effects: [
                        {
                            effect: new core_1.InvulnerableEffectArgs(),
                            duration: Duration_1.Duration.Ticks(1)
                        },
                        {
                            effect: new core_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Health, container.getPercentOfBaseHealth(event.subject, 33)),
                            duration: Duration_1.Duration.Instant,
                        },
                        {
                            duration: Duration_1.Duration.Ticks(handler.args.scriptArgs.ticks),
                            effect: new core_1.OutOfTimeEffectArgs(handler.args.scriptArgs.ticks),
                        }
                    ]
                });
            }
        });
    }
};
Ability_OutOfTime_OnDeathAvoidedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_OutOfTime_OnDeathAvoided")
], Ability_OutOfTime_OnDeathAvoidedEventHandlerScript);
exports.Ability_OutOfTime_OnDeathAvoidedEventHandlerScript = Ability_OutOfTime_OnDeathAvoidedEventHandlerScript;
